<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">Ｐコード一発選定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="column-list">
          <label class="list-input-title">Ｐコード</label>
          <div class="list-input-content">
            <input type="text" class="text-label-required pcode" id="txti_pcode" [(ngModel)]="kymw1304Model.pCode"
              plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8" [autofocus]="true" (input)="txtiPCodeChanged()"
              [tabindex]="0" />
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button class="btn-primary" id="btn_select" [disabled]="!kymw1304Model.enabled"
            (click)="btnSelectClicked()" [tabindex]="0">選定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>